import { produce } from 'immer';
import {
  RESET_CREATE_CONTENT,
  RESET_UPLOAD_IMAGE,
  UPLOAD_IMAGE_ACTION,
} from '../actions/createContentActionTypes';
import { FormType } from '../enums/commonEnums';
import {
  GET_ALL_TEMPLATES_TRACKER,
  RESET_TEMPLATE_FORM,
  UPDATE_FORM_TYPE,
  UPDATE_MESSAGE_CONTENT,
  UPDATE_MESSAGE_CONTENT_ID,
  UPDATE_TEMPLATE_CREATE_STATUS,
  UPDATE_TEMPLATE_DELETE_STATUS,
  UPDATE_TEMPLATE_EDIT_STATUS,
  UPDATE_TEMPLATE_NAME,
  UPDATE_TEMPLATE_SUBJECT,
} from './../actions/nudgeActionTypes';

const intialState = {
  selectedContentId: '',
  formMode: FormType.NEW,
  createStatus: null,
  editStatus: null,
  deleteStatus: null,
  subject: '',
  templateName: '',
  contentElements: [],
  imageDetails: {},
  templateList: {
    data: [],
    status: '',
  },
};
export default function createContent(state = intialState, action) {
  return produce(state, draftState => {
    switch (action.type) {
      case UPDATE_MESSAGE_CONTENT: {
        draftState.contentElements = action.payload ?? [];
        break;
      }
      case UPDATE_MESSAGE_CONTENT_ID: {
        draftState.selectedContentId = action.payload ?? '';
        break;
      }
      case GET_ALL_TEMPLATES_TRACKER: {
        draftState.templateList = action.payload ?? {};
        break;
      }
      case UPLOAD_IMAGE_ACTION: {
        draftState.imageDetails = action.payload;
        break;
      }
      case RESET_UPLOAD_IMAGE: {
        draftState.imageDetails = {};
        break;
      }
      case RESET_CREATE_CONTENT: {
        draftState.imageDetails = {};
        draftState.contentElements = [];
        draftState.selectedContentId = '';
        break;
      }
      case UPDATE_TEMPLATE_SUBJECT: {
        draftState.subject = action.payload;
        break;
      }
      case UPDATE_FORM_TYPE: {
        draftState.formMode = action.payload;
        break;
      }
      case UPDATE_TEMPLATE_NAME: {
        draftState.templateName = action.payload;
        break;
      }
      case RESET_TEMPLATE_FORM: {
        draftState.selectedContentId = '';
        draftState.subject = '';
        draftState.templateName = '';
        draftState.contentElements = [];
        draftState.imageDetails = {};
        draftState.formMode = FormType.NEW;
        draftState.createStatus = null;
        draftState.deleteStatus = null;
        draftState.editStatus = null;
        break;
      }
      case UPDATE_TEMPLATE_CREATE_STATUS: {
        draftState.createStatus = action.payload;
        break;
      }
      case UPDATE_TEMPLATE_EDIT_STATUS: {
        draftState.editStatus = action.payload;
        break;
      }
      case UPDATE_TEMPLATE_DELETE_STATUS: {
        draftState.deleteStatus = action.payload;
        break;
      }
      default: {
        break;
      }
    }
  });
}
